import { createSlice } from "@reduxjs/toolkit";
import { AIState } from "../types/ai";

const initialState: AIState = {
  isAIMode: JSON.parse(localStorage.getItem("PS-AIMode") || "false"),
  resetTrigger: 0,
  selectedChatMessages: [],
  isSelectedChatLoading: false,
  selectedChatMessagesId: null,
  selectedChatTitle: undefined,
};

const aiSlice = createSlice({
  name: "ai",
  initialState,
  reducers: {
    toggleAIMode: (state) => {
      state.isAIMode = !state.isAIMode;
      localStorage.setItem("PS-AIMode", String(state.isAIMode));
    },

    setAIMode: (state, action) => {
      state.isAIMode = action.payload;
      localStorage.setItem("PS-AIMode", String(action.payload));
    },
    resetChat: (state) => {
      state.resetTrigger = Date.now();
    },
    setSelectedChatMessages: (state, action) => {
      state.selectedChatMessages = action.payload;
    },
    setSelectedChatLoading: (state, action) => {
      state.isSelectedChatLoading = action.payload;
    },
    setSelectedChatMessagesId: (state, action) => {
      state.selectedChatMessagesId = action.payload;
    },
    setSelectedChatTitle: (state, action) => {
      state.selectedChatTitle = action.payload;
    },
  },
});

export const {
  toggleAIMode,
  setAIMode,
  resetChat,
  setSelectedChatMessages,
  setSelectedChatLoading,
  setSelectedChatMessagesId,
  setSelectedChatTitle,
} = aiSlice.actions;
export default aiSlice.reducer;
